import addClass from "./hooks/addClass";

export default class DoAnimator {
    clearAnimations() {
        for (let i = 0; i < ApexChat.animationArray.length; i++) {
            const intervalName = ApexChat[`animationInterval${ApexChat.animationArray[i]}`];
            window.clearInterval(intervalName);
        }
    }

    flip(element, interval) {
        ApexChat.animationArray.push('Flip');
        ApexChat.animationIntervalFlip = setInterval(() => {
            element.classList.add('animated', 'rotary');
            setTimeout(() => {
                element.classList.remove('animated', 'rotary');
            }, 1000);
        }, interval);
    }

    flipCoin(element, interval) {
        ApexChat.animationArray.push('FlipCoin');
        ApexChat.animationIntervalFlipCoin = setInterval(() => {
            element.classList.add('animated', 'flipCoin');
            setTimeout(() => {
                element.classList.remove('animated', 'flipCoin');
            }, 3000);
        }, interval);
    }

    glow(options, interval) {
        ApexChat.animationArray.push('Glow');
        options.wrapperDiv.classList.add('apexchat_rd_dom_patch_top_for_glow');
        addClass(options.parentDiv, 'apexchat_rd_dom_patch_height_for_glow');
        addClass(options.iframeDiv, 'apexchat_rd_dom_patch_height_for_glow');
        options.element.classList.add('apexchat_nobox_shadow');
        ApexChat.animationIntervalGlow = setInterval(() => {
            options.element.classList.remove('animated', 'glow');
            setTimeout(() => {
                options.element.classList.remove('animated', 'glow');
            }, 3000);
        }, interval);
    }
}
